import { useI18n } from "@wojo/localization";
import { AlertBasic } from "@wojo/ui";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React from "react";
import { QuoteCheckoutType } from "../../../../generated/graphql";
import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";
dayjs.extend(utc);

export const QuoteNotice: React.FC = () => {
    const { draftQuote, error } = useTripBuilderQuote();
    const { productPage } = useI18n("productPage");
    const isPayInFullOnly = draftQuote?.order.checkoutOptions.every(
        (option) => option.type === QuoteCheckoutType.PayInFull,
    );

    if (!isPayInFullOnly) {
        return null;
    }
    return (
        <>
            <AlertBasic
                status="info"
                title={productPage.tripBuilder.quote.mustPayInFull.l()}
            />
            {!!error && (
                <AlertBasic status="alert" title={error} role="alert" />
            )}
        </>
    );
};
